import React from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Data
import data from "./data/historyData";

import Divider from "@mui/material/Divider";

function History() {
  const renderData = data.map(({ title, description, items }, index) => (
    <React.Fragment key={title}>
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid item xs={12} lg={3}>
          <MKBox position="sticky" top="100px" pb={{ xs: 2, lg: 6 }} sx={{ textAlign: "center" }}>
            <MKTypography
              variant="h3"
              fontWeight="bold"
              mb={1}
              sx={{ textAlign: "center", color: "rgb(104, 52, 155)" }}
            >
              {title}
            </MKTypography>
            <MKTypography
              variant="body2"
              fontWeight="regular"
              color="secondary"
              mb={1}
              pr={2}
              sx={{ textAlign: "center" }}
            >
              {description}
            </MKTypography>
          </MKBox>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={8}
          sx={{
            transform: {
              xs: "scale(0.9)",
              sm: "scale(0.95)",
              md: "scale(1)",
            },
            transformOrigin: "center",
          }}
        >
          {items.map((text, index) => (
            <MKBox key={`${title}-${index}`} mb={2}>
              <MKTypography
                variant="body2"
                color="black"
                sx={{
                  fontSize: { xs: "0.8rem", sm: "0.875rem", md: "1rem" },
                }}
              >
                {text}
              </MKTypography>
            </MKBox>
          ))}
        </Grid>
      </Grid>
      {index < data.length - 1 && (
        <Divider sx={{ my: 2 }} /> // 구분선 추가, 마지막 요소 제외
      )}
    </React.Fragment>
  ));

  return (
    <MKBox component="section" my={{ xs: 4, sm: 6 }} py={{ xs: 4, sm: 6 }}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection="column"
          alignItems="center"
          sx={{
            textAlign: "center",
            my: { xs: 4, sm: 6 },
            mx: "auto",
            px: { xs: 0.5, sm: 0.75 },
          }}
        >
          <MKTypography
            variant="h2"
            fontWeight="bold"
            sx={{
              fontSize: { xs: "1.2rem", sm: "2rem", md: "2.5rem" },
            }}
          >
            JOHEUNBICH(좋은빛) 주요 연혁
          </MKTypography>
          <MKTypography
            variant="body1"
            color="text"
            sx={{
              fontSize: { xs: "0.875rem", sm: "1rem", md: "1.125rem" },
            }}
          >
            SINCE 2017 ~
          </MKTypography>
        </Grid>
      </Container>
      <Container>{renderData}</Container>
    </MKBox>
  );
}

export default History;
